module.exports = __webpack_public_path__ + "img/pdd.02148ce7.jpeg";